import React from 'react';
import UploadLabel from "../UploadLabel/UploadLabel";
import FileUploader from 'react-firebase-file-uploader';
import { Field } from 'formik';

class FileUpload extends React.Component {

  state = {
    isUploading: false,
    progress: 0
  };

  // File Upload handlers.
  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = (progress) => this.setState({ progress });
  handleUploadError = (e) => { console.log(e); this.setState({ isUploading: false }); };
  handleUploadSuccess = (filename, directory, item, resolve) => {
    this.setState({ [item]: filename, progress: 100, isUploading: false });
    this.props.firebase
        .storage()
        .ref(directory)
        .child(filename)
        .getDownloadURL()
        .then(data => { resolve(data) });
  };

  render() {
    return (<Field name={ this.props.name }>
      {({ field, form }) => (<div><UploadLabel>
        { this.props.label }
        <FileUploader
            accept="image/*"
            name="photo"
            hidden
            filename={ file => file.name.split('.')[0] + '-thumbnail' }
            storageRef={ this.props.firebase.storage().ref(this.props.directory) }
            onUploadStart={ this.handleUploadStart }
            onUploadError={ this.handleUploadError }
            onUploadSuccess={ (file) => { const f = new Promise((resolve, reject) => {
              this.handleUploadSuccess(file, this.props.directory, 'thumbnail', resolve);
            }).then( (data) => { form.setFieldValue(this.props.name, data) })   } }
            onProgress={ this.handleProgress }
        /></UploadLabel>
        { this.state.isUploading ?
            <div className="hint">Uploading { this.state.progress}%</div> :
            <div className="hint">{ this.props.hint }</div> }
      </div>)}
    </Field>)
  }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js